import jsonLogic from 'json-logic-js';
import type { CastedValue, QAMetadata, ResolveValuePermutations } from '../type/common/types';
import type { Rule } from '../type/rule';
import { QaCheckError, QaCheckErrorCode } from './error';
const {
  apply
} = jsonLogic;
export const validateRuleWithData = <Binding, Types>(resolvedValues: ResolveValuePermutations<Types>, rule: Rule<Binding>) => {
  const validationResult: {
    result: boolean;
    metadata: QAMetadata<Types>[];
  }[] = [];
  for (const [index, resolvedValue] of resolvedValues.entries()) {
    const {
      dataForEvaluation,
      metadata
    } = getPreparedDataForValidation(resolvedValue);
    const result = apply(rule.expression, dataForEvaluation);
    if (typeof result !== 'boolean') {
      return new QaCheckError(`The expression result should be of type boolean but is of type ${typeof result}`, QaCheckErrorCode.invalidRuleResponse);
    }
    validationResult[index] = {
      result,
      metadata
    };
  }
  return validationResult;
};
const getPreparedDataForValidation = <Types,>(resolvedValue: ResolveValuePermutations<Types>[number]) => {
  return Object.entries(resolvedValue).reduce<{
    dataForEvaluation: {
      [alias: string]: {
        [subAlias: string]: CastedValue;
      };
    };
    metadata: QAMetadata<Types>[];
  }>((preparedData, [alias, {
    values,
    metadata
  }]) => {
    const updatedData = preparedData;
    updatedData.dataForEvaluation[alias] = values;
    updatedData.metadata.push(metadata);
    return updatedData;
  }, {
    dataForEvaluation: {},
    metadata: []
  });
};